<template>
	<!-- <pre>{{ feTheme }}</pre> -->
	<n-config-provider :theme-overrides="theme" :locale="locale" :date-locale="dateLocale" >
		<div style="display: flex; flex-flow: column nowrap">
			<n-date-picker v-model:value="range" type="daterange" size="medium" clearable @update:value="datePickerUpdate" @clear="reset" />
				<!-- <pre>{{ JSON.stringify(range) }}</pre> -->
			</div>
	</n-config-provider>
</template>

<script>
import { NConfigProvider, NInput, NDatePicker, NSpace } from 'naive-ui'
// theme
import { createTheme, datePickerDark } from 'naive-ui'
// locale
import { enGB, dateEnGB, esES, dateEsES, itIT, dateItIT, frFR, dateFrFR, deDE, dateDeDE } from 'naive-ui'

import moment from 'moment'

export default {
	components: {
		NDatePicker,
		NConfigProvider
	},

	props: {
		dtPost: Object,
		dateFilters: Object,
		feTheme: {
			type: Object,
			default: {}
		}
	},

	emits: ['date-update'],

	data() {
		// console.log('theme::', createTheme( [datePickerDark] ).DatePicker.common )


		/**
		 * Use this for type hints under js file
		 * @type import('naive-ui').GlobalThemeOverrides
		 */
		const themeOverrides = {
		    common: {
				primaryColor: this.feTheme.date_picker_active_background_color,
				// boxShadowFocus: 'red'
				// primaryColorHover: this.feTheme.date_picker_hover_color,
				// textColorActive: 'red',
				// itemTextColorActive: 'red',
				
		    },
		    Button: {
				textColor: this.feTheme.primary_color,
				// common: {
					colorHover: this.feTheme.date_picker_active_background_color,
					textColorHover: this.feTheme.date_picker_active_color,
				// }
		    },
			DatePicker: {
				itemTextColorActive: this.feTheme.date_picker_active_color,
				itemColorHover: this.feTheme.date_picker_hover_background_color,
				// boxShadowFocus: 'red'
				// itemTextColorHover: this.feTheme.date_picker_hover_color,
				// common: {
				// 	// hoverColor: this.feTheme.date_picker_hover_background_color,
				// 	textColor1: this.feTheme.date_picker_hover_color,
				// 	textColor3: 'blue',
				// 	itemTextColorActive: 'red',
				// },
			}
		}
		    // ...
		// console.log('this.dateFilters::', this.dateFilters)


        /*
         * If it is a chart modify the default start date of the date range picker so that if
         * Chart period = daily => start date is set to -1 month
         * Chart period = weekly => start date is set to -6 months
         * Chart period = monthly => start date is set to -1 year
         * Chart period = yearly => start date is set to -6 years
         *
         * Was discussed here: https://gitlab.com/ryter/custom/boxed/plugin/-/issues/275#note_1664201113
         */
        let range;
        if(this.dtPost.post_type === 'bryter-dt-chart') {
            const period = this.dtPost.chart_period ?? false,
                date = moment();

            let startDate;
            if(period && period === 'daily') {
                startDate = date.subtract(1, 'months')
            } else if(period && period === 'weekly') {
                startDate = date.subtract(6, 'months')
            } else if(period && period === 'monthly') {
                startDate = date.subtract(1, 'years')
            } else if(period && period === 'yearly') {
                startDate = date.subtract(6, 'years')
            } else {
                startDate = this.dateFilters.options.minDate * 1000;
            }

            range = [ this.dateFilters != null ? startDate.valueOf() : Date.now(), Date.now() ]

        } else {
            range = [ this.dateFilters != null ? this.dateFilters.options.minDate * 1000 : Date.now(), Date.now() ]
        }


		
		return {
			// range: [118313526e4, Date.now()],
			// range: [ this.dateFilters.options.minDate * 1000, this.dateFilters.options.maxDate * 1000 ],
			range,
			theme: themeOverrides,
        	locale: deDE,
        	dateLocale: dateDeDE,
        	// to be removed
        	// startDate: this.dateFilters.options.minDate * 1000,
        	endDate: Date.now()
		}
	},

	methods: {
		datePickerUpdate(range) {
			this.$emit('date-update', range)
		},
		getDatePair(date_format) {
			const pairs = {
				'DD-MM-YYYY': 'dd-MM-yyyy',
				'MM-DD-YYYY': 'MM-dd-yyyy',
				'YYYY-MM-DD': 'yyyy-MM-dd',
				'DD/MM/YYYY': 'dd/MM/yyyy',
				'MM/DD/YYYY': 'MM/dd/yyyy',
				'DD.MM.YYYY': 'dd.MM.yyyy',
				'D MMMM YYYY': 'd MMMM yyyy',
			}

			return pairs[date_format];
		},
		reset() {
			// let _this = this
			// setTimeout(function(){
			// 	_this.range = [ _this.dateFilters != null ? _this.dateFilters.options.minDate * 1000 : Date.now(), Date.now() ]
			// }, 10)
		}
	},

	created() {
		
		switch (window.charts_locale) {
			case 'en':
				this.locale = enGB
				this.dateLocale = dateEnGB
				break;
			case 'de':
				this.locale = deDE
				this.dateLocale = dateDeDE
				break;
		}

		if ( window.date_format ) {
			this.locale.DatePicker.dateFormat = this.getDatePair(window.date_format)
		}

		this.emitter.on('reset-all-ev', (evt) => {
			this.range = [ this.dateFilters != null ? this.dateFilters.options.minDate * 1000 : Date.now(), Date.now() ]
	    })
	}
}
</script>